import { render, staticRenderFns } from "./equipDetail.vue?vue&type=template&id=0d6a349e&scoped=true"
import script from "./equipDetail.vue?vue&type=script&lang=js"
export * from "./equipDetail.vue?vue&type=script&lang=js"
import style0 from "./equipDetail.vue?vue&type=style&index=0&id=0d6a349e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a349e",
  null
  
)

export default component.exports